/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Private_Models_Edit_TitleInputs */



/**
* | output |
* | --- |
* | "Edit Private Model" |
*
* @param {Private_Models_Edit_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_edit_title = /** @type {((inputs?: Private_Models_Edit_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_Edit_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Privates Modell bearbeiten")
	return /** @type {LocalizedString} */ ("Edit Private Model")
});